import styled from '@emotion/styled';
import React from 'react';

import {
  ClaimOverviewThumbnail,
  PhotoRequirementsThumbnail,
  PopThumbnail,
} from '../../../../../assets/images/warranty-claim';

const Container = styled.div`
  width: 100%;

  .video-thumbnails {
    display: flex;
    justify-content: ${props => (props.mid ? 'center' : 'space-between')};
    margin: 2rem 0;

    div {
      width: 32%;
      padding: 0.2rem;
      border: 1px solid #000;
      border-radius: 3px;
      text-align: center;

      img {
        width: 100%;
        cursor: pointer;
        opacity: 0.9;
        transition: all 0.3s ease;

        &:hover {
          opacity: 1;
          scale: 1.1;
        }
      }

      &:hover {
        border: none;
        shadow: 2px 2px 2px #000;
      }
    }
  }
`;

const allThumbnails = [
  {
    img: ClaimOverviewThumbnail,
    alt: 'Claim Overview Thumbnail',
    name: 'claim-overview',
    href: 'https://www.youtube.com/watch?v=TN_tqnrELLc',
  },
  {
    img: PhotoRequirementsThumbnail,
    alt: 'Photo Requirements Thumbnail',
    name: 'photo-requirements',
    href: 'https://www.youtube.com/watch?v=aF9hPtYNsIE',
  },
  {
    img: PopThumbnail,
    alt: 'Proof of Purchase Thumbnail',
    name: 'proof-of-purchase',
    href: 'https://www.youtube.com/watch?v=kk_uNXkR3XY',
  },
];

const VideoThumbnails = ({ show = 'all', mid = '' }) => {
  const thumnails = show === 'all' ? allThumbnails : allThumbnails.filter(thumbnail => thumbnail.name === show);

  return (
    <Container mid={mid}>
      <div className="video-thumbnails">
        {thumnails.map((thumbnail, index) => (
          <div key={index}>
            <a
              href={thumbnail.href}
              target="_blank"
              rel="noreferrer"
              data-track="form-advance"
              data-track-form-name="Submit Claim"
            >
              <img src={thumbnail.img} alt={thumbnail.alt} />
            </a>
          </div>
        ))}
      </div>
    </Container>
  );
};

export default VideoThumbnails;
